export default theme => ({
  // used on all inputs (generic styling)
  defaultText: {
    fontSize: 18,
  },

  input: {
    width: '100%',
    background: 'white',
    transition: 'all 0.25s ease-in-out',

    '&:focus': {
      outline: 'none',
    },
    alignSelf: 'stretch',
  },

  textInput: {
    border: '2px solid lightgray',
    borderRadius: 5,
    padding: 10,
    textAlign: 'center',
    // background: '#eee',
  },
  selectInputDisabled: {
    border: '2px solid lightgray',
    borderRadius: 5,
  },

  inputLabel: {
    fontSize: '1rem',
    textAlign: 'center',
    fontWeight: 'bold',
    marginTop: 15,
    marginBottom: 5,
  },

  disabledText: {
    color: '#888',
  },

  disabledInput: {
    color: 'rgba(0,0,0,0.6)',
    background: 'transparent',
    borderColor: 'rgba(0,0,0,0.05)',
  },

  textLabelError: {
    color: 'red',
    fontWeight: 'bold',
  },

  textInputError: {
    borderBottom: '2px solid red',
  },

  selectInputError: {
    border: '2px solid red',
    borderRadius: '4px',
  },
});
